import { render, staticRenderFns } from "./CreateParametritation.vue?vue&type=template&id=6ccd72ab&"
import script from "./CreateParametritation.vue?vue&type=script&lang=js&"
export * from "./CreateParametritation.vue?vue&type=script&lang=js&"
import style0 from "./CreateParametritation.vue?vue&type=style&index=0&id=6ccd72ab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports